import { BackofficeNotificationAPI } from 'api/build/backofficeNotificationAPI';

export * from 'api/build/backofficeNotificationAPI';
// eslint-disable-next-line
export default new BackofficeNotificationAPI();
